import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedReviewListResponse, IExtendedReview, ReviewQueryParams } from '@frontend/review/types';

export class ReviewExtendedClient extends APIClient {
    public static readonly endpoint = '/review-api/ext/v1';

    public static async fetchExtendedReviews(queryParams?: ApiQueryParams<ReviewQueryParams>): Promise<ExtendedReviewListResponse> {
        return await this.apiPaginated<ExtendedReviewListResponse, ReviewQueryParams>(`${this.endpoint}/reviews`, queryParams);
    }

    public static async fetchExtendedReview(accountId: string, reviewId: string): Promise<IExtendedReview> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}`);
        return await this.handleResponse<IExtendedReview>(response);
    }
}
